import { ApiUtility } from "./ApiUtility";

export interface ISearchParams {
  productType: string;
  language: string;
  searchValue: string;
  authorId: string;
}

class SearchDataService {
  searchRoute = "/api/settings/search?=lang=";
  profilepath = "/api/user/profilepicture?id="

  profileimg = (userId: string) => {
    return ApiUtility.get(
      this.profilepath + userId + "&isThumb=" + 1
    );
  };

  // https://apidev.gitaseva.org/v1/api/Settings/search?lang=hindi&product=all&searchtext=05%2F05%2F2022&authorId=authorss

  searchData = (product: string, searchtext: string, authorId: string) => {
    return ApiUtility.get(
      this.searchRoute +
      localStorage?.getItem("lan") +
      "&product=" +
      product +
      "&searchtext=" +
      searchtext +
      "&authorId=" +
      authorId
    );
  };
}
export default new SearchDataService();
